import { apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { publicDataMock, publicPageMock } from './mock';
import { publicPath } from '../../utils/paths';

export default {
  publicData: () => {
    if (shouldUseMock()) {
      return publicDataMock();
    }
    return apiCallPublic(`${baseUrl}${publicPath}homepage`, 'GET');
  },
  publicPage: (id) => {
    if (shouldUseMock()) {
      return publicPageMock(id);
    }
    return apiCallPublic(`${baseUrl}${publicPath}page/${id}`, 'GET');
  },
};
